import { SideBarMenuItem } from 'src/app/models/side-bar-menu-item';
import { UserAccessLevelGroupName } from 'src/app/enums/user-access-level-group-name.enum';
import { AppFeatures } from 'src/app/enums/app-features.enum';
import { AppRouteEnum } from 'src/app/enums/app-route.enum';
import { practiceAdminEntryMenuItem } from 'src/app/components/side-bar/consts/practice-admin-entry.const';

export const generalIopMenuItemsGroup: SideBarMenuItem[] = [
  {
    icon: 'patients',
    routerLink: 'patients',
    name: 'Patients'
  },
  {
    icon: 'order',
    accessLevelGroup: UserAccessLevelGroupName.OrdersAccessLevelGroup,
    name: 'Orders',
    menuItems: <SideBarMenuItem[]>[
      {
        icon: '',
        routerLink: ['orders', 'emr-orders'],
        name: 'Find EMR Order',
        feature: AppFeatures.EmrOrders
      },
      {
        icon: '',
        routerLink: [AppRouteEnum.Orders, AppRouteEnum.OrderRequisitionBatch],
        name: 'Generate Requisition Batch',
        feature: AppFeatures.OrderRequisitionBatch
      },
      {
        icon: '',
        routerLink: [AppRouteEnum.Orders, AppRouteEnum.OrderRequisitionBatchReports],
        name: 'Requisition Batch Reports'
      }
    ]
  },
  {
    icon: 'results',
    accessLevelGroup: UserAccessLevelGroupName.ResultsAccessLevelGroup,
    name: 'Results',
    menuItems: <SideBarMenuItem[]>[
      {
        icon: '',
        routerLink: [AppRouteEnum.Results],
        name: 'Results Inbox',
        feature: AppFeatures.Results
      },
      {
        icon: '',
        routerLink: [AppRouteEnum.BatchResults],
        name: 'Batch Results',
        feature: AppFeatures.BatchResults
      },
      {
        icon: '',
        routerLink: [AppRouteEnum.BatchResults, 'generate'],
        name: 'Generate Batch Results',
        feature: AppFeatures.BatchResults
      },
      {
        icon: '',
        routerLink: [AppRouteEnum.GlobalResultsSearch],
        name: 'Global Results Search',
        feature: AppFeatures.GlobalResultsSearch
      },
      {
        icon: '',
        routerLink: [AppRouteEnum.GlobalResultsReports],
        name: 'Global Results Reports',
        feature: AppFeatures.GlobalResultsReports
      }
    ]
  },
  practiceAdminEntryMenuItem
];
